import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import NavItem from 'components/app/topbar/navigation/NavItem';
import DropdownMenu from 'react-dd-menu';
import { MenuItem } from 'components/menu/MenuItems';

import { withRouter } from 'react-router-dom';
import { selectClientConfigurations } from 'state/user/selectors';
import { RouteUrls } from 'routes/RouteConstants';
import { usePermissions, AppFeaturePermissions } from 'contexts';

const LeasesMenu = (props) => {
    const { featurePermissions } = usePermissions();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = useCallback(() => {
        setIsMenuOpen(!isMenuOpen);
    }, [isMenuOpen]);

    const closeMenu = useCallback(() => {
        setIsMenuOpen(false);
    }, []);

    const renderButton = useCallback(() => {
        const { isTenants, isLeases, isLarge, isExpirations, isRentRoll } =
            props;

        return (
            <NavItem
                title={isLarge ? 'Leasing' : ''}
                active={isTenants || isLeases || isExpirations || isRentRoll}
                icon="assets/img/Leases-Icon-White@2x.png"
                onClick={toggleMenu}
                hideTooltip={true}
                dropdown
            >
                <i
                    className="fa-solid fa-caret-down"
                    size="lg"
                    style={{
                        paddingLeft: isLarge ? '6px' : '3px',
                        fontSize: '16px',
                    }}
                />
            </NavItem>
        );
    }, [
        props.isTenants,
        props.isLeases,
        props.isLarge,
        props.isExpirations,
        props.isRentRoll,
        toggleMenu,
    ]);

    const showPerformanceOverview = featurePermissions?.includes(
        AppFeaturePermissions.PerformanceOverview
    );
    const showRentRoll = featurePermissions?.includes(
        AppFeaturePermissions.RentRoll
    );
    const showExpirationSchedule = featurePermissions?.includes(
        AppFeaturePermissions.ExpirationSchedule
    );
    const showTenants = featurePermissions?.includes(
        AppFeaturePermissions.Tenants
    );

    if (
        !showPerformanceOverview &&
        !showRentRoll &&
        !showExpirationSchedule &&
        !showTenants
    ) {
        return null;
    }

    const {
        tenantsEnabled,
        isTenants,
        isLeases,
        expirationEnabled,
        isExpirations,
        rentRollEnabled,
        isRentRoll,
    } = props;

    return (
        <DropdownMenu
            animate={false}
            align="left"
            isOpen={isMenuOpen}
            toggle={renderButton()}
            close={toggleMenu}
        >
            {showPerformanceOverview && (
                <MenuItem
                    active={isLeases}
                    style={{ width: '180px' }}
                    to={RouteUrls.LEASES_PERFORMANCE_OVERVIEW}
                >
                    <span>Performance Overview</span>
                </MenuItem>
            )}
            {rentRollEnabled && showRentRoll && (
                <MenuItem
                    active={isRentRoll}
                    style={{ width: '180px' }}
                    to={RouteUrls.LEASE_RENT_ROLL}
                >
                    <span>Rent Roll</span>
                </MenuItem>
            )}
            {expirationEnabled && showExpirationSchedule && (
                <MenuItem
                    active={isExpirations}
                    style={{ width: '180px' }}
                    to={RouteUrls.LEASES_EXPIRATIONS_SCHEDULE}
                >
                    <span>Expiration Schedule</span>
                </MenuItem>
            )}
            {tenantsEnabled && showTenants && (
                <MenuItem
                    active={isTenants}
                    style={{ width: '180px' }}
                    to={RouteUrls.LEASES_TENANTS}
                >
                    <span>Tenants</span>
                </MenuItem>
            )}
        </DropdownMenu>
    );
};

LeasesMenu.propTypes = {
    active: PropTypes.bool,
    isLarge: PropTypes.bool,
    router: PropTypes.object,
    tenantsEnabled: PropTypes.bool,
    isTenants: PropTypes.bool,
    isLeases: PropTypes.bool,
};

export default withRouter(
    connect((state) => {
        const {
            browser: { mediaType },
        } = state;

        const {
            routing: {
                locationBeforeTransitions: { pathname },
            },
        } = state;

        const clientConfig = selectClientConfigurations(state);
        const {
            FEATURE_TENANTS: tenantsEnabled,
            FEATURE_EXPIRATION_SCHEDULE: expirationEnabled,
            FEATURE_RENT_ROLL: rentRollEnabled,
        } = clientConfig;

        const isTenants = pathname.includes(RouteUrls.LEASES_TENANTS);
        const isLeases = pathname.includes(
            RouteUrls.LEASES_PERFORMANCE_OVERVIEW
        );
        const isExpirations = pathname.includes(
            RouteUrls.LEASES_EXPIRATIONS_SCHEDULE
        );
        const isRentRoll = pathname.includes(RouteUrls.LEASE_RENT_ROLL);

        return {
            tenantsEnabled,
            expirationEnabled,
            rentRollEnabled,
            isLarge: mediaType === 'lg',
            isTenants,
            isLeases,
            isExpirations,
            isRentRoll,
        };
    })(LeasesMenu)
);
